<template>
  <div>
    <div class="news">
      <div class="my-news">
        <div class="u-flex u-row-between w100">
          <div class="title">工单记录</div>
          <div class="u-flex">
            <el-button type="primary" size="small" @click="workShow = true">提交工单</el-button>
          </div>
        </div>
      </div>
      <el-table class="whitelist-table mt20" :data="dataSource">
        <el-table-column prop="word_sn" label="工单编号" align="center"/>
        <el-table-column prop="title" label="问题类型" align="center"/>
        <el-table-column prop="time" label="提交时间" align="center">
          <template #default="scope">
            {{ formatTime(scope.row.createtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="工单进度" align="center">
          <template #default="scope">
            <el-tag v-if="scope.row.status == 0" type="danger">未回复</el-tag>
            <el-tag v-if="scope.row.status == 1" type="success">已回复</el-tag>
            <!-- <el-tag v-if="scope.row.status == 2" type="warning">关闭</el-tag>    -->
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" align="center">
          <template #default="scope">
            <el-button type="text" @click="handleDetail(scope.row)">查看</el-button>
            <!-- <el-button type="text" size="small" @click="closeWork(scope.row)" v-if="scope.row.status == 0 || scope.row.status == 1" >关闭</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background @current-change="(e) => { page = e; getData() }" layout="total,prev, pager, next"
                     :total="total" :page-size="5"/>
    </div>
    <el-dialog title="提交工单" :visible.sync="workShow" @close="form = this.$options.data().form; workShow = false"
               width="50%">
      <el-form :model="form" label-width="100px" ref="form">
        <el-form-item label="问题类型" prop="title" :rules="[{ required: true, message: '请输入问题类型' }]">
          <el-input v-model="form.title" placeholder="请输入问题类型"/>
        </el-form-item>

        <el-form-item label="问题描述" prop="content" :rules="[{ required: true, message: '请输入问题描述' }]">
          <el-input type="textarea" v-model="form.content" placeholder="请输入问题描述"/>
        </el-form-item>
        <el-form-item label="上传图片" prop="img">
          <upload @getImg="(data) => upload(data)" :img-url="form.img" key="img" :isDuotu="false"/>
        </el-form-item>

      </el-form>
      <template #footer>
        <el-button type="primary" @click="submit" size="mini">提交</el-button>
      </template>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="detailShow" width="50%">
      <el-descriptions :column="3" border>
        <el-descriptions-item label="工单编号">{{ detailData.word_sn }}</el-descriptions-item>
        <el-descriptions-item label="问题类型">{{ detailData.title }}</el-descriptions-item>
        <el-descriptions-item label="问题描述">{{ detailData.content }}</el-descriptions-item>
        <el-descriptions-item label="上传图片" v-if="detailData.img">
          <el-button type="text" @click="handleViewImage(detailData.img)">查看图片</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="提交时间">{{ formatTime(detailData.createtime) }}</el-descriptions-item>
        <el-descriptions-item label="工单进度">
          <el-tag v-if="detailData.status == 0" type="danger">未处理</el-tag>
          <el-tag v-if="detailData.status == 1" type="success">已处理</el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="处理时间" v-if="detailData.status == 1">{{
            formatTime(detailData.updatetime)
          }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="3" title="处理内容"/>
      <div class="processing-content" v-html="detailData.processing_content"></div>

    </el-dialog>


  </div>
</template>

<script>
import upload from "@/components/upload.vue";

export default {
  components: {
    upload
  },
  name: 'Index',
  data() {
    return {
      page: 1,
      total: 0,
      type: '',
      workShow: false,
      dataSource: [],
      submitShow: false,
      form: {
        title: '',
        content: '',
        img: '',
      },
      detailShow: false,
      detailData: {},
      replyShow: false,
      replyForm: {
        content: '',
        img: '',
      },
    }

  },
  mounted() {
    this.curIdx = this.$route.params.index || 0
  },
  created() {
    this.getData()
  },
  methods: {
    onTab(index) {
      this.navIndex = index
    },
    upload(data) {
      this.form.img = data.fullurl
    },
    getData() {
      this.$api.workOrder.getList({page: this.page}).then(res => {
        this.dataSource = res.data.data
        this.total = res.data.total
      })
    },
    handleDetail(row) {
      this.$api.workOrder.getDetail({word_sn: row.word_sn}).then(res => {
        this.detailData = res.data.row
        this.detailShow = true
      })
    },


    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.workOrder.submitWordOrder(this.form).then(res => {
            this.getData()
            this.$message.success('提交成功')
            this.workShow = false
            this.form = this.$options.data().form
          })
        }
      })
    },
    formatTime(ts) {
      if (!ts) return '-';
      // 支持10位和13位时间戳
      const t = ts.toString().length === 10 ? ts * 1000 : ts;
      const d = new Date(t);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
    handleViewImage(imgUrl) {
      if (!imgUrl) {
        this.$message.warning('图片地址无效');
        return;
      }
      try {
        window.open(imgUrl);
      } catch (error) {
        console.error('打开图片失败:', error);
        this.$message.error('打开图片失败');
      }
    }
  }
}
</script>

<style scoped>
.news {
  margin-top: 20px;
  border-radius: 8px;
//border: 1px solid #ccc;
}

.whitelist-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.whitelist-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.whitelist-table ::v-deep tr {
  transition: background 0.2s;
}

.whitelist-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.whitelist-table ::v-deep td,
.whitelist-table ::v-deep th {
  padding: 12px 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.my-news {
  padding: 20px;
}

.table ::v-deep tr th {
  background: #f5f5f5;
}

.table::before {
  height: 0;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

::v-deep .el-textarea__inner {
  height: 200px;
}

/* 聊天界面样式 */
.chat-container {
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #f8f9fa;
}

.chat-title {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.chat-messages {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.message-item {
  margin-bottom: 20px;
}

.message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.service-message {
  flex-direction: row;
}

.user-message {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.service-message .message-avatar {
  background: #409eff;
  color: white;
}

.user-message .message-avatar {
  background: #67c23a;
  color: white;
}

.message-content {
  flex: 1;
  max-width: 70%;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #909399;
}

.message-name {
  font-weight: 600;
  color: #606266;
}

.message-time {
  color: #c0c4cc;
}

.message-text {
  padding: 12px 16px;
  border-radius: 8px;
  word-wrap: break-word;
  line-height: 1.5;
}

.service-message .message-text {
  background: #fff;
  border: 1px solid #e4e7ed;
  color: #303133;
}

.user-message .message-text {
  background: #409eff;
  color: white;
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
